import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

let routerList = [
  {
    path: '/ggrc/',
    component: () => import('@/views/index')
  },
  {
    path: '/ggrc/list',
    component: () => import('@/views/list/index')
  },
  {
    path: '/ggrc/detail',
    component: () => import('@/views/list/detail')
  },
  {
    path: '/ggrc/jobfair',
    component: () => import('@/views/jobfair/index')
  },
  {
    path: '/ggrc/subject',
    component: () => import('@/views/subject/index')
  },
  {
    path: '/ggrc/guidance',
    component: () => import('@/views/guidance/index')
  },
  {
    path: '/ggrc/guidance/dajs',
    component: () => import('@/views/guidance/dajs')
  },
  {
    path: '/ggrc/guidance/cjxgzm',
    component: () => import('@/views/guidance/cjxgzm')
  },
  {
    path: '/ggrc/guidance/dacjyfw',
    component: () => import('@/views/guidance/dacjyfw')
  },
  {
    path: '/ggrc/guidance/daclbc',
    component: () => import('@/views/guidance/daclbc')
  },
  {
    path: '/ggrc/guidance/dazc',
    component: () => import('@/views/guidance/dazc')
  },
  {
    path: '/ggrc/guidance/gxbysbd',
    component: () => import('@/views/guidance/gxbysbd')
  },
  {
    path: '/ggrc/guidance/jthkgl',
    component: () => import('@/views/guidance/jthkgl')
  },
  {
    path: '/ggrc/guidance/zskcfw',
    component: () => import('@/views/guidance/zskcfw')
  },
  {
    path: '*',
    component: () => import('@/views/error-page/notFound')
  }
]

const router = new Router({
  mode: 'history',
  routes: routerList
})

router.beforeEach((to, from, next) => {
  let _path = to.fullPath
  // console.log(_path)
  if (_path.indexOf('/ggrc') < 0) {
    _path = '/ggrc' + _path
    next({ path: _path })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js